import { Component, EventEmitter, Input, Output } from '@angular/core'
import { DynamicTextWidget } from 'htv-lib'
import { BaseWidgetComponent } from '../base-widget/base-widget.component'

@Component({
  selector: 'app-dynamic-text-widget',
  standalone: true,
  imports: [],
  templateUrl: './dynamic-text.component.html',
  styleUrls: ['./dynamic-text.component.scss'],
})
export class DynamicTextComponent extends BaseWidgetComponent {
  @Input() text!: string
  @Input() singleLine = true
  @Input() allowOverflow = false
  @Input() selectable = false
  @Input() containerAlignItems = 'center'
  @Output() clicked = new EventEmitter<any>()

  override enableVisibilityControl = true

  constructor() {
    super()
  }

  override applyStyles(): void {
    super.applyStyles()

    const config = this.config as DynamicTextWidget
    const containerStyle: Record<string, string | number> = {}
    const contentStyle: Record<string, string | number> = {}

    if (config.color) {
      contentStyle['color'] = config.color
    }

    if (config.fontFamily) {
      contentStyle['font-family'] = config.fontFamily
    }

    if (config.fontSize) {
      contentStyle['font-size'] = `${this.scaleToResolution(config.fontSize)}px`
    }

    if (config.alignment) {
      contentStyle['text-align'] = `${config.alignment}`
    }

    if (config.fontWeight) {
      contentStyle['font-weight'] = `${config.fontWeight}`
    }

    if (this.singleLine) {
      contentStyle['text-overflow'] = 'ellipsis'
      contentStyle['white-space'] = 'nowrap'
    }

    if (this.allowOverflow) {
      containerStyle['overflow'] = 'visible'
      contentStyle['overflow'] = 'visible'
    }

    if (this.containerAlignItems !== 'center') {
      containerStyle['align-items'] = this.containerAlignItems
    }

    this.setRule('.container', containerStyle)
    this.setRule('.content', contentStyle)
  }

  onClick(): void {
    this.clicked.emit()
  }
}
